import React, { createContext, useState, ReactNode } from "react";
import { api } from "../api/shared/functions";

export interface FormData {
  email: string;
  phone: string;
  phoneVerificationId: string;
  captcha: string;
  captchaHash: string;
  code: string;
  codeHash: string;
  password: string;
  confirmPassword: string;
  firstName: string;
  lastName: string;
  country: string;
  role: string;
  dob: Date;
}

export interface SignupContextType {
  formData: FormData;
  updateFormData: React.Dispatch<React.SetStateAction<FormData>>;
  loading: boolean;
  callApi: () => Promise<boolean>;
  createPhoneUser: () => Promise<boolean>;
  verifyOtp: () => Promise<boolean>;
}

// export const AuthContext = createContext<IAuth>(defaultValue);
const signupInitialState: SignupContextType = {
  formData: {
    email: "",
    phone: "",
    phoneVerificationId: "",
    captcha: "",
    captchaHash: "",
    code: "",
    codeHash: "",
    password: "",
    confirmPassword: "",
    firstName: "",
    lastName: "",
    country: "",
    role: "creator",
    dob: new Date(),
  },
  updateFormData: () => {}, // Provide a no-op function for the initial updateFormData
  loading: false,
  callApi: async () => false, // Provide a no-op async function that returns false
  createPhoneUser: async () => false,
  verifyOtp: async () => false, // Provide a no-op async function that returns false
};

export const SignupContext = createContext<SignupContextType>(signupInitialState);

interface SignupProviderProps {
  children: ReactNode;
}

const SignupProvider = ({ children }: SignupProviderProps) => {
  const [formData, updateFormData] = useState<FormData>({
    email: "",
    phone: "",
    phoneVerificationId: "",
    captcha: "",
    captchaHash: "",
    code: "",
    codeHash: "",
    password: "",
    confirmPassword: "",
    firstName: "",
    lastName: "",
    country: "",
    role: "creator",
    dob: new Date(),
  });
  const [loading, setLoading] = useState<boolean>(false);

  // const updateFormData: React.Dispatch<React.SetStateAction<FormData>> = value => {
  //   setFormData(value);
  // };

  // const verifyCaptcha = async (): Promise<boolean> => {
  //   let { captcha, captchaHash } = formData;
  //   let data = { text: captcha, hash: captchaHash };
  //   //setLoading(true);
  //   try {
  //     // Replace this with your actual API call
  //     await api.post("/verify-captcha", data);
  //     return true;
  //   } catch (error) {
  //     console.log(error);
  //     return false;
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const verifyOtp = async (): Promise<boolean> => {
    let data = { code: formData.code ?? "" };
    setLoading(true);
    try {
      // Replace this with your actual API call
      await api.post("/verifyCode", data);
      return true;
    } catch (error) {
      // Handle error
      return false;
    } finally {
      setLoading(false);
    }
  };

  const callApi = async (): Promise<boolean> => {
    const data = {
      email: formData.email,
      password: formData.password,
      firstName: formData.firstName,
      lastName: formData.lastName,
      role: formData.role,
      dob: formData.dob,
    };
    setLoading(true);
    try {
      await api.post("/signup", data);
      return true;
      // Handle success response
    } catch (error) {
      // Handle error
      return false;
    } finally {
      setLoading(false);
    }
  };

  const createPhoneUser = async (): Promise<boolean> => {
    const data = {
      phone: formData.email,
      firstName: formData.firstName,
      lastName: formData.lastName,
      role: formData.role,
      dob: formData.dob,
    };
    setLoading(true);
    try {
      await api.post("/addUser", data);
      return true;
      // Handle success response
    } catch (error) {
      // Handle error
      return false;
    } finally {
      setLoading(false);
    }
  };

  return (
    <SignupContext.Provider value={{ formData, updateFormData, loading, callApi, createPhoneUser, verifyOtp }}>{children}</SignupContext.Provider>
  );
};

export default SignupProvider;
